__turbopack_context__.v({
  "className": "dancing_script_cb21e830-module__O-h1ca__className",
});
